import React, { useState } from 'react';
import { Typography, TextField, Table, TableHead, TableRow, TableCell, TableBody, Paper, TableContainer } from '@mui/material';
import DateRangeFilter, { defaultStart, defaultEnd } from './DateRangeFilter';
import { ReportStaff } from '../../../api';
import dayjs from 'dayjs';

const StaffReport = ({ access }) => {
  const [start, setStart] = useState(defaultStart());
  const [end, setEnd] = useState(defaultEnd());
  const [staffName, setStaffName] = useState('');
  const [rows, setRows] = useState([]);

  const run = () =>
    ReportStaff(access?.org?.id, { start, end, staffName }).then(setRows).catch(() => {});

  return (
    <>
      <Typography variant="h6" sx={{ mb: 2 }}>Staff Report</Typography>
      <DateRangeFilter start={start} end={end} onStart={setStart} onEnd={setEnd} onSubmit={run}
        extra={<TextField label="Staff Name" size="small" value={staffName} onChange={e => setStaffName(e.target.value)} />}
      />
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Owner</TableCell>
              <TableCell>Date / Time</TableCell>
              <TableCell>Reason</TableCell>
              <TableCell>Acknowledged By</TableCell>
              <TableCell>Checked Out By</TableCell>
              <TableCell>Wait (min)</TableCell>
              <TableCell>Service (min)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(r => (
              <TableRow key={r.id}>
                <TableCell>{r.ownerName}</TableCell>
                <TableCell>{dayjs(r.createdAt).format('MM/DD/YY h:mm A')}</TableCell>
                <TableCell>{[r.reason?.label, r.subreason?.label].filter(Boolean).join(' / ')}</TableCell>
                <TableCell>{r.acknowledgedBy?.name || '—'}</TableCell>
                <TableCell>{r.completedBy?.name || '—'}</TableCell>
                <TableCell>{r.waitMinutes ?? '—'}</TableCell>
                <TableCell>{r.serviceMinutes ?? '—'}</TableCell>
              </TableRow>
            ))}
            {!rows.length && <TableRow><TableCell colSpan={7} align="center">No results</TableCell></TableRow>}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default StaffReport;
